/**
 * Format a monetary value to a specific currency
 */
export const formatCurrency = (
    amount: number | string | undefined | null,
    currencyCode = 'USD',
    locale = 'en-US'
): string => {
    if (amount === undefined || amount === null) {
        return '';
    }

    const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

    if (isNaN(numericAmount)) {
        return '';
    }
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numericAmount);
};

/**
 * Formats a donation amount using exchange amount if available
 */
export const formatDonationAmount = (
    amount?: number | string | null,
    exchangeAmount?: number | string | null,
    originalCurrency = 'USD'
): string => {
    if (exchangeAmount !== undefined && exchangeAmount !== null && exchangeAmount !== 0) {
        return formatCurrency(exchangeAmount, 'USD');
    }

    return formatCurrency(amount, originalCurrency);
};
